import React, { createContext, useContext, useEffect, useState } from "react";
import { authStore } from "./authStore";
import { permissionService } from "./permissionService";

interface AuthState {
  token: string | null;
  user: any;
  loading: boolean;
}

const AuthContext = createContext<AuthState>({
  token: null,
  user: null,
  loading: true
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {

  const [token, setToken] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const handleKeycloakSuccess = async (event: any) => {

      const token = event.detail.token;
      const profile = event.detail.profile;

      authStore.setToken(token);
      authStore.setIsLoggedIn(true);

      setToken(token);
      setUser(profile);

      // 🔥 permissions AFTER token
      await permissionService.initPermissions();

      setLoading(false);
    };

    // usermgmt web component refreshed the token: keep context state in sync
    const handleTokenRefreshed = (event: any) => {
      setToken(event.detail.token);
    };

    window.addEventListener("keycloak-auth-success", handleKeycloakSuccess);
    window.addEventListener("keycloak-token-refreshed", handleTokenRefreshed);

    return () => {
      window.removeEventListener("keycloak-auth-success", handleKeycloakSuccess);
      window.removeEventListener("keycloak-token-refreshed", handleTokenRefreshed);
    };

  }, []);

  return (
    <AuthContext.Provider value={{ token, user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);